import axios from "axios"
import { RegistrarLogErro } from "./clientefiel"

const url = "https://5anmf3q26c.execute-api.us-east-1.amazonaws.com/api"

const apiLambdaAgendamento = axios.create({
    baseURL: url,
})

function tratamentoResponse(response, chamada) {
    if (response.data.codErro > 0)
        return { retornoErro: response.data.codErro, mensagem: response.data.mensagem }
    else if (typeof response.data == "string" && response.data != "")
        return {
            retornoErro: 1,
            mensagem: chamada + " - Erro inesperado, entre em contato com os reponsáveis.",
        }
    else return response.data
}

const ErroRequisicao = function (data, aplicativoDados) {
    try {
        console.log("ErroRequisicao> ", data.request, data.message)
        if (data.message == "Network Error") {
            return "Verifique sua conexão!"
        } else if (data.message) {
            return "Erro: " + data.message
        }
        return false
    } catch (error) {
        RegistrarLogErro(error, "ErroRequisicao", data)
    }
}

export const cadastrarConfiguracoesAgendamento = async (idEstabelecimento, autorizacao) => {
    const data = {}
    const url = `/agendamento/configuracoes/criar/${idEstabelecimento}`
    const headers = {
        "Content-Type": "application/json",
        Authorization: autorizacao,
    }

    try {
        const response = await apiLambdaAgendamento.post(url, data, { headers: headers })
        return tratamentoResponse(response, "buscarFihcasTecnicas")
    } catch (error) {
        const erro = ErroRequisicao(error)
        return { retornoErro: 1, mensagem: erro }
        // RegistrarLogErro(error, "cadastrarConfiguracoesAgendamento")
    }
}

export const buscarConfiguracoesAgendamento = async (idEstabelecimento, autorizacao) => {
    const url = `/agendamento/configuracoes/buscar/${idEstabelecimento}`
    const headers = {
        "Content-Type": "application/json",
        Authorization: autorizacao,
    }

    try {
        const response = await apiLambdaAgendamento.get(url, { headers: headers })
        return tratamentoResponse(response, "buscarConfiguracoesAgendamento")
    } catch (error) {
        const erro = ErroRequisicao(error)
        return { retornoErro: 1, mensagem: erro }
        // RegistrarLogErro(error, "buscarConfiguracoesAgendamento")
    }
}

export const atualizarConfiguracaoAgendamento = async (data, idEstabelecimento, autorizacao) => {
    data.aceiteAutomatico = Boolean(data.aceiteAutomatico)

    const url = `/agendamento/configuracoes/atualizar/${idEstabelecimento}`
    const headers = {
        "Content-Type": "application/json",
        Authorization: autorizacao,
    }

    try {
        const response = await apiLambdaAgendamento.put(url, data, { headers: headers })
        return tratamentoResponse(response, "Atualizar Configuracao Agendamento")
    } catch (error) {
        const erro = ErroRequisicao(error)
        return { retornoErro: 1, mensagem: erro }
        // RegistrarLogErro(error, "cadastrarCategoria")
    }
}

export const buscarPeriodoDeAgendamento = async (idEstabelecimento, autorizacao) => {
    const url = `/agendamento/periodos/buscar/painel/${idEstabelecimento}`
    const headers = {
        "Content-Type": "application/json",
        Authorization: autorizacao,
    }

    try {
        const response = await apiLambdaAgendamento.get(url, { headers: headers })
        return tratamentoResponse(response, "Atualizar Configuracao Agendamento")
    } catch (error) {
        const erro = ErroRequisicao(error)
        return { retornoErro: 1, mensagem: erro }
        // RegistrarLogErro(error, "cadastrarCategoria")
    }
}

export const cadastrarPeriodoDeAgendamento = async (data, idEstabelecimento, autorizacao) => {
    const url = `/agendamento/periodos/criar/${idEstabelecimento}`
    const headers = {
        "Content-Type": "application/json",
        Authorization: autorizacao,
    }

    try {
        const response = await apiLambdaAgendamento.post(url, data, { headers: headers })
        return tratamentoResponse(response, "Atualizar Configuracao Agendamento")
    } catch (error) {
        const erro = ErroRequisicao(error)
        return { retornoErro: 1, mensagem: erro }
        // RegistrarLogErro(error, "cadastrarCategoria")
    }
}

export const deletarPeriodoDeAgendamento = async (idPeriodo, idEstabelecimento, autorizacao) => {
    const url = `/agendamento/periodos/deletar/${idPeriodo}/${idEstabelecimento}`
    const headers = {
        "Content-Type": "application/json",
        Authorization: autorizacao,
    }

    try {
        const response = await apiLambdaAgendamento.delete(url, { headers: headers })
        return tratamentoResponse(response, "Atualizar Configuracao Agendamento")
    } catch (error) {
        const erro = ErroRequisicao(error)
        return { retornoErro: 1, mensagem: erro }
        // RegistrarLogErro(error, "cadastrarCategoria")
    }
}

export const atualizarPeriodoDeAgendamento = async (data, idEstabelecimento, autorizacao) => {
    const url = `/agendamento/periodos/atualizar/${idEstabelecimento}`
    const headers = {
        "Content-Type": "application/json",
        Authorization: autorizacao,
    }

    try {
        const response = await apiLambdaAgendamento.put(url, data, { headers: headers })
        return tratamentoResponse(response, "Atualizar Configuracao Agendamento")
    } catch (error) {
        const erro = ErroRequisicao(error)
        return { retornoErro: 1, mensagem: erro }
        // RegistrarLogErro(error, "cadastrarCategoria")
    }
}

export const buscarPedidosAgendados = async (idEstabelecimento, autorizacao) => {
    const url = `/agendamento/pedidos/buscar/${idEstabelecimento}`
    const headers = {
        "Content-Type": "application/json",
        Authorization: autorizacao,
    }

    try {
        const response = await apiLambdaAgendamento.get(url, { headers: headers })
        return tratamentoResponse(response, "Atualizar Configuracao Agendamento")
    } catch (error) {
        const erro = ErroRequisicao(error)
        return { retornoErro: 1, mensagem: erro }
        // RegistrarLogErro(error, "cadastrarCategoria")
    }
}

export const aceitarPedidoAgendado = async (data, idEstabelecimento, autorizacao) => {
    const url = `/agendamento/pedidos/aceitar/${idEstabelecimento}`
    const headers = {
        "Content-Type": "application/json",
        Authorization: autorizacao,
    }

    try {
        const response = await apiLambdaAgendamento.put(url, data, { headers: headers })
        return tratamentoResponse(response, "Atualizar Configuracao Agendamento")
    } catch (error) {
        const erro = ErroRequisicao(error)
        return { retornoErro: 1, mensagem: erro }
        // RegistrarLogErro(error, "cadastrarCategoria")
    }
}

export const cancelarPedidoAgendado = async (data, idEstabelecimento, autorizacao) => {
    const url = `/agendamento/pedidos/cancelar/${idEstabelecimento}`
    const headers = {
        "Content-Type": "application/json",
        Authorization: autorizacao,
    }

    try {
        const response = await apiLambdaAgendamento.put(url, data, { headers: headers })
        return tratamentoResponse(response, "Atualizar Configuracao Agendamento")
    } catch (error) {
        const erro = ErroRequisicao(error)
        return { retornoErro: 1, mensagem: erro }
        // RegistrarLogErro(error, "cadastrarCategoria")
    }
}

export const finalizarPedidoAgendado = async (data, idEstabelecimento, autorizacao) => {
    const url = `/agendamento/pedidos/finalizar/${idEstabelecimento}`
    const headers = {
        "Content-Type": "application/json",
        Authorization: autorizacao,
    }

    try {
        const response = await apiLambdaAgendamento.put(url, data, { headers: headers })
        return tratamentoResponse(response, "Atualizar Configuracao Agendamento")
    } catch (error) {
        const erro = ErroRequisicao(error)
        return { retornoErro: 1, mensagem: erro }
        // RegistrarLogErro(error, "cadastrarCategoria")
    }
}

export const buscarPeriodosDeAgendamentoPedidos = async (data, idEstabelecimento) => {
    const url = `/agendamento/periodos/buscar/site/${data}/${idEstabelecimento}`
    const headers = {
        "Content-Type": "application/json",
    }

    try {
        const response = await apiLambdaAgendamento.get(url, { headers: headers })
        return response.data
    } catch (error) {
        RegistrarLogErro(error, "buscarPeriodosDeAgendamento")
        console.log(error)
    }
}
